import moduleConfig from "./health_care.config";

export default [
  {
    path: `${moduleConfig.basePath}/:market/:marketid`,
    component: () => import("./health_care.module"),
    children: [
      {
        path: '',
        name: 'health-care',
        component: () => import("./views/health_care.vue"),
      },
      {
        path: ":items",
        name: "health-care-listing",
        component: () => import("./views/health_careListing.vue"),
      },
      {
        path: 'orderPrescription/:categoryid',
        name: 'order-prescription',
        component: () => import("./views/order_prescription.vue"),
      },
      {
        path: 'pharmacyListing',
        name: 'pharmacy-listing',
        component: () => import("./views/pharmacyListing.vue"),
      },
      {
        path: 'quote',
        name: 'request-quote',
        component: () => import("./views/requestQuote.vue"),
      },
      {
        path: 'pharmacyShop/:categoryid',
        name: 'pharmacy-Shop',
        component: () => import("./views/pharmacyShop.vue"),
      },
      {
        path: 'specializationListing/:categoryid',
        name: 'looking-for-doctor',
        component: () => import("./views/specialization_listing.vue"),
      },
      {
        path: 'ordermedicine/medicinecategory',
        name: 'healthcare-product-list',
        component: () => import("./views/product_listing.vue"),
      },
      {
        path: 'lookingfordoctor/doctorlisting',
        name: 'doctor-listing',
        component: () => import("./views/doctor_listing.vue"),
      },
      {
        path: 'bookatest/packagetest',
        name: 'package-test',
        component: () => import("./views/packageTests.vue"),
      },
      {
        path: 'homeSampleCollection/:marketid',
        name: 'home-sample-collection',
        component: () => import("./views/homeSampleCollection.vue"),
      },
      {
        path: 'lookingForPhysiotherapist/:marketid',
        name: 'looking-for-physiotherapist',
        component: () => import("./views/lookingForPhysiotherapist.vue"),
      },
      {
        path: 'hospitalListing/:marketid',
        name: 'hospital-listing',
        component: () => import("./views/hospitalListing.vue"),
      },
      {
        path: 'hospitalDetails',
        name: 'hospital-details',
        component: () => import("./views/hospital_details.vue"),
      },
      {
        path: 'diagnosticCenters/:marketid',
        name: 'diagnostic-centers',
        component: () => import("./views/diagnostic_centers.vue"),
      },
      {
        path: 'diagnosticCenterList',
        name: 'diagnostic-center-listing',
        component: () => import("./views/diagnostic_center_list.vue"),
      },
      {
        path: 'diagnosticCenterDetails',
        name: 'diagnostic-center-detail',
        component: () => import("./views/diagnostic_center_details.vue"),
      },
    ],
  },
];

